export const SET_CHAT_LABEL = "@CHAT_LABELS/SET";
export const SET_CHAT_LABEL_LIST = "@CHAT_LABELS/SET_LIST";
